"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Chat_1 = require("../Chat");
const ChatMessage_1 = require("../ChatMessage");
class NullChatRepository {
    async InitAsync() { }
    async ClearAsync() { }
    async ChatOfIdAsync(id) { return Chat_1.Chat.INVALID_CHAT; }
    async ChatOfChatMessageAsync(cm) { return Chat_1.Chat.INVALID_CHAT; }
    async FindChatByTempIdAsync(tempId) { return Chat_1.Chat.INVALID_CHAT; }
    async ActiveChatsOfUserAsync(username) { return []; }
    async SaveAsync(chat) { }
    async LoadAsync(id) { return Chat_1.Chat.INVALID_CHAT; }
    async LoadWithSpecifiedChatMessageCountAsync(id, retrieveChatMessageCount) { return Chat_1.Chat.INVALID_CHAT; }
    async LoadBeforeAsync(id, beforeThisChatMessage, retrieveChatMessageCount) { return Chat_1.Chat.INVALID_CHAT; }
    async LoadAfterAsync(id, afterThisChatMessage, retrieveChatMessageCount) { return Chat_1.Chat.INVALID_CHAT; }
    async DeleteAsync(id) { }
    async LoadChatMessageBeforeAsync(chatId, refOrdinal, retrieveChatMessageCount) { return []; }
    async SaveChatMessageAsync(chatId, cm) { return ChatMessage_1.ChatMessage.INVALID_CHAT_MESSAGE; }
    async SaveChatMessagesAsync(chatId, cms) { return []; }
    async DoesChatMessageExists(cm) { return false; }
    async LoadChatMessageAsync(chatId, cmId) { return ChatMessage_1.ChatMessage.INVALID_CHAT_MESSAGE; }
    async LoadChatMessagesAsync(chatId, cmIds) { return []; }
    async UpdateChatMessage(cm) { }
    GenerateId(participants = []) { return ""; }
}
exports.NullChatRepository = NullChatRepository;
exports.NullChatRepositorySigleton = new NullChatRepository();
//# sourceMappingURL=NullChatRepository.js.map